import { RetornoVerificaRetificacaoTO } from "src/app/pagamento/models/retorno-verifica-retificacao-to";

export const RETORNO_VERIFICA_RETIFICACAO_CNPJ_COMPLETA_MOCK: RetornoVerificaRetificacaoTO = {
  "codigoRetorno": 0, 
  "mensagemRetorno": "", 
  "podeFazerRetificacao": true, 
  "podeRetificarPABase2": false, 
  "periodoApuracaoBase2": null, 
  "camposAlteraveis": [ 
    { "nomeCampo": "processo", "alteravel": false, "valor": null }, 
    { "nomeCampo": "origemErro", "alteravel": false, "valor": 2 }, 
    { "nomeCampo": "processoAlteracao", "alteravel": true, "valor": null }, 
    { "nomeCampo": "ni", "alteravel": true, "valor": "12229753000152" }, 
    { "nomeCampo": "dataArrecadacao", "alteravel": false, "valor": "2024-01-22" }, 
    { "nomeCampo": "codigoBanco", "alteravel": false, "valor": "001" }, 
    { "nomeCampo": "codigoAgencia", "alteravel": false, "valor": "0013" }, 
    { "nomeCampo": "valorTotal", "alteravel": false, "valor": 3568.67 }, 
    { "nomeCampo": "periodoApuracao", "alteravel": true, "valor": "2023-12-18" }, 
    { "nomeCampo": "dataVencimento", "alteravel": true, "valor": "2024-01-22" }, 
    { "nomeCampo": "referencia", "alteravel": true, "valor": "21180093200951900" }, 
    { "nomeCampo": "idCEF", "alteravel": false, "valor": null }, 
    { "nomeCampo": "codigoReceita01", "alteravel": true, "valor": "6092" }, 
    { "nomeCampo": "codigoReceita02", "alteravel": true, "valor": null }, 
    { "nomeCampo": "codigoReceita03", "alteravel": true, "valor": null }, 
    { "nomeCampo": "valorReceita01", "alteravel": true, "valor": 3568.67 }, 
    { "nomeCampo": "valorReceita02", "alteravel": true, "valor": null }, 
    { "nomeCampo": "valorReceita03", "alteravel": true, "valor": null }, 
    { "nomeCampo": "vrba", "alteravel": true, "valor": null }, 
    { "nomeCampo": "vrbaPercentual", "alteravel": true, "valor": null } 
  ], 
  "podeAlterarCodReceitas": null
};
